var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.onJump('work')}}},[_vm._v("作文管理平台")]),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.onJump('shop')}}},[_vm._v("商城管理后台")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }